var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed z-[9999] cursor-pointer outline-none",style:(_vm.style),attrs:{"tabindex":"0"},on:{"blur":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }